import {Injectable} from "@angular/core";
import {confirmObject} from "../../models/confirms.model";

@Injectable({providedIn: 'root'})
export class CacheConfirmService {
  storeSelectedConfirms: Map<string, confirmObject> = new Map<string, confirmObject>();
  isEditEnable: boolean = false;
  cacheConfirmations: confirmObject[] = [];
  masterCache: Set<confirmObject> = new Set();
  cachedYear: string = '';
  cachedMonth: string = '';
  cachedConfirmType: string = '';
}
